export function isLeaf(node) {
  return node.field !== undefined;
}
/**
 * A function used to process headerClassName params.
 */